export default __webpack_public_path__ + "images/d6fb3a9dddc8228cc7220c0585efc9fd-gaming.jpg";